<style lang="scss" scoped>
// .equ {
//   position: absolute;
//   width: 415px;
//   height: 200px;
//   right: 1px;
//   top: 658px;
//   cursor: pointer;
//   background-image: url("../../../../../assets/pagesImg/fire-system.png");
// }
.equ{
  width: 415px;
  height: 200px;
  margin-top: 20px;
  cursor: pointer;
  .xiaofang{
    margin-top: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-evenly;
    .data{
      height: 92px;
      font-size: 18px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .number{
        font-size: 48px;
        font-family: 'dina';
      }
    }
    .data:nth-child(1){
      .number{
        color:#2D82FF;
      }
    }
    .data:nth-child(3){
      .number{
        color:#F1802F;
      }
    }
    
  }
}
</style>

<template>
  <div class="equ" @click="routeGoFire">
    <custom-plane title="消防系统 (烟感)"
    :iconImg="require('@/assets/compImg/fireIcon/smoke.png')">
    <div class="xiaofang">
        <div v-for="(item,index) in xiaofangList1" :key="index" class="data">
            <p>{{item.title}}</p>
            <p class="number">{{item.num}}</p>
        </div>
    </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  data(){
      return{
        
      }
    },
    props:{
      xiaofangList1:Array
    },
  methods: {
    routeGoFire() {
      this.$router.push({
        name: "fourth-fourth",
        path: "/firecontrol",
        params: { id: 0 },
      });
    },
  },
};
</script>
